import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppContext } from "../context/AppContext";
import appConstants from "../constants/appConstants";
import { Modal, Table } from "react-bootstrap";
import { Navbar, Form, Button, Dropdown, Container, Row, Col } from "react-bootstrap";
import "./Topbar.css";

const Topbar = () => {
  const navigate = useNavigate();
  const { institute, user, setUser, fetchInstituteData } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [students, setStudents] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      navigate("/login");
    } else {
      const rowUser = localStorage.getItem("userData");
      setUser(JSON.parse(rowUser));
      fetchInstituteData();
    }
  }, [navigate]);

  const handleChangePassword = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("All fields are required!");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match!");
      return;
    }

    const token = localStorage.getItem("authToken");
    const payload = {
      old_password: oldPassword,
      new_password: newPassword,
    };

    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}change-staff-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (response.ok) {
        alert(data.message || "Password Changed");
        setShowPasswordModal(false);
      } else {
        alert(data.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Login error:", error);
    }

    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    setShowModal(false);
  };

  const handleLogout = async (type = "one") => {
    if (loading) return;
    setLoading(true);
    const authToken = localStorage.getItem("authToken");
    localStorage.removeItem("authToken");
    const logoutEndpoint = type === "all" ? "staff-logout-all" : "staff-logout-one";
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}${logoutEndpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.ok) {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.error("Network error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;
    setLoading(true);
    const token = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}student-search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ search: searchTerm }),
      });
      const data = await response.json();
      if (data.direct_match) {
        if (data.student) {
          navigate(`/student-summary/${data.student.id}`);
        }
      } else {
        setStudents(data.students);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      setLoading(false);
    }
  };

  const selectStudent = (student) => {
    setShowModal(false);
    navigate(`/student-summary/${student.id}`);
  };

  return (
    <Navbar expand="md" bg="light" className="shadow-sm px-3">
      <Container fluid>
        <Navbar.Brand>
          {institute ? institute.name : "No Institute Loaded"}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        <Navbar.Collapse id="responsive-navbar-nav">
          <Form
            className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center w-100 my-2 my-md-0"
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            <Form.Control
              type="text"
              placeholder="Search students..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onDoubleClick={() => setSearchTerm("")}
              className="me-md-2 mb-2 mb-md-0"
            />
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Searching..." : "Search"}
            </Button>
          </Form>

          <Dropdown align="end" className="ms-md-3 mt-2 mt-md-0">
            <Dropdown.Toggle variant="light" className="d-flex align-items-center">
              <img
                src={user?.profileImage || `${appConstants.API_ROOT_URL}uploads/students/blank.png`}
                alt="Profile"
                className="rounded-circle"
                width="32"
                height="32"
              />
              <span className="ms-2">{user?.name || "User"}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setShowPasswordModal(true)}>Change Password</Dropdown.Item>
              <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              <Dropdown.Item className="d-none" onClick={() => handleLogout("all")}>Logout All</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.Collapse>
      </Container>

      {/* Student Search Results Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Search Results</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Ad.#</th>
                <th>Name</th>
                <th>Class</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student, index) => (
                <tr
                  key={student.student_id}
                  onClick={() => selectStudent(student)}
                  style={{
                    backgroundColor: student.suspended ? "#ffcccc" : "white",
                    cursor: "pointer",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{student.admission_no || `App: ${student.application_no}`}</td>
                  <td>{student.name}</td>
                  <td>{student.batch_detail}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>

      {/* Change Password Modal */}
      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Old Password</Form.Label>
              <Form.Control
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPasswordModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleChangePassword}>
            Change Password
          </Button>
        </Modal.Footer>
      </Modal>
    </Navbar>
  );
};

export default Topbar;
